import { request } from '@umijs/max';

export type AccessSession = {
  id: string;
  userId: string;
  userName?: string | null;
  loginType?: string | null;
  ip?: string | null;
  userAgent?: string | null;
  clientKind: string;
  deviceType: string;
  osName?: string | null;
  browserName?: string | null;
  deviceName?: string | null;
  loginAt: string;
  lastSeenAt: string;
  logoutAt?: string | null;
  online: boolean;
  onlineSeconds: number;
  user?: {
    id: string;
    name: string;
    username: string;
    avatar?: string | null;
  };
};

export type OperationLog = {
  id: string;
  userId?: string | null;
  userName?: string | null;
  method: string;
  path: string;
  module?: string | null;
  summary?: string | null;
  statusCode?: number | null;
  success: boolean;
  durationMs?: number | null;
  ip?: string | null;
  userAgent?: string | null;
  requestSummary?: string | null;
  errorMessage?: string | null;
  createdAt: string;
};

export type UserPresence = {
  user: {
    id: string;
    name: string;
    username: string;
    avatar?: string | null;
  };
  currentOnline: boolean;
  latestSession: AccessSession | null;
  sessions: AccessSession[];
  onlineSecondsByDay: Array<{ date: string; seconds: number }>;
  statusSeries: Array<{ at: string; online: number }>;
  totalOnlineSeconds: number;
};

export async function postAccessHeartbeat(sessionId?: string) {
  return request<{
    success: boolean;
    data: {
      sessionId: string;
      online: boolean;
      onlineSeconds: number;
      lastSeenAt: string;
    };
  }>('/api/erp/access/heartbeat', {
    method: 'POST',
    data: { sessionId },
    skipErrorHandler: true,
  });
}

export async function listAccessSessions(params?: Record<string, any>) {
  return request<{
    success: boolean;
    data: {
      list: AccessSession[];
      total: number;
      page: number;
      pageSize: number;
    };
  }>('/api/erp/settings/access/sessions', { method: 'GET', params });
}

export async function listOnlineUsers() {
  return request<{ success: boolean; data: AccessSession[] }>(
    '/api/erp/settings/access/online',
    { method: 'GET' },
  );
}

export async function getUserPresence(
  userId: string,
  params?: { from?: string; to?: string },
) {
  return request<{ success: boolean; data: UserPresence }>(
    `/api/erp/settings/access/users/${userId}/presence`,
    { method: 'GET', params },
  );
}

export async function listOperationLogs(params?: Record<string, any>) {
  return request<{
    success: boolean;
    data: {
      list: OperationLog[];
      total: number;
      page: number;
      pageSize: number;
    };
  }>('/api/erp/settings/operation-logs', { method: 'GET', params });
}
